/**
 * TrustpilotWidget — static, brand-compliant Trustpilot badge.
 *
 * Replaces the former script-hydrated TrustBox (which never rendered stars —
 * invalid Business Unit ID — and fell back to a bare text link that was
 * invisible on the dark-green footer, breaching Trustpilot brand guidelines).
 *
 * This renders the official lockup exactly as Trustpilot's brand asset:
 *   • five #00B67A star tiles with white stars
 *   • green Trustpilot star + #191919 "Trustpilot" wordmark
 *   • always on a white card so it is legible on ANY background
 * Links to the public review page.
 */
const TP_GREEN = "#00B67A";
const TP_INK = "#191919";
const STAR_POINTS = "12,2.2 15.1,8.9 22.4,9.7 17,14.7 18.5,21.9 12,18.2 5.5,21.9 7,14.7 1.6,9.7 8.9,8.9";

const StarGlyph = ({ size, fill }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
        <polygon points={STAR_POINTS} fill={fill} />
    </svg>
);

const StarTile = ({ size }) => (
    <span
        className="inline-flex items-center justify-center"
        style={{ width: size, height: size, backgroundColor: TP_GREEN, borderRadius: Math.max(2, size * 0.09) }}
    >
        <StarGlyph size={size * 0.74} fill="#ffffff" />
    </span>
);

export default function TrustpilotWidget({ starSize = 26, className = "" }) {
    const wordmarkPx = Math.round(starSize * 0.82);
    return (
        <a
            href="https://www.trustpilot.com/review/myecotour.in"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="MyEcoTour reviews on Trustpilot"
            data-testid="trustpilot-badge"
            className={`inline-flex flex-col items-start gap-2.5 bg-white border border-black/5 rounded-lg px-4 py-3 shadow-sm hover:shadow transition-shadow ${className}`}
        >
            <span className="flex items-center" style={{ gap: Math.max(3, starSize * 0.14) }}>
                {[0, 1, 2, 3, 4].map((i) => <StarTile key={i} size={starSize} />)}
            </span>
            <span className="flex items-center" style={{ gap: Math.max(4, starSize * 0.2) }}>
                <StarGlyph size={wordmarkPx * 1.15} fill={TP_GREEN} />
                <span
                    className="font-semibold tracking-tight leading-none"
                    style={{ color: TP_INK, fontSize: wordmarkPx, fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif" }}
                >
                    Trustpilot
                </span>
            </span>
        </a>
    );
}
